import { connect, useDispatch } from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { s3Link } from "../../../utils/constants";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import {
    getAlbums,
    setActiveAlbum,
    setAlbumAction,
    setStashAlbumListScrollPosition
} from "../../../../redux/actions/stash";
import ModalBootstrap from "react-bootstrap/Modal";
import AlertConfirmModal from "../../AlertConfirmModal";
import { captureException } from "@sentry/browser";
import axios from "axios";

const AlbumList = ({
    activeAlbum,
    albumList,
    loadingStash,
    albumListScrollTopPosition,
    maxSelection = 0,
}) => {
    const dispatch = useDispatch();
    const [confirmAlbumID, setConfirmAlbumID] = useState('');
    const [renameAlbum, setRenameAlbum] = useState('');
    const [modalBody, setModalBody] = useState('');
    const [showRenameFolder, setShowRenameFolder] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [action, setAction] = useState('');
    const [confirmAction, setConfirmAction] = useState(false);

    const handleShowRenameFolder = () => {
        setShowRenameFolder(!showRenameFolder);
    };

    const handleAlertFunction = () => {
        if (action === 'rename')
            return closeAlert();

        if (action === 'delete') {
            return deleteAlbum();
        }
    };

    const deleteAlbumConfirm = (albumId = '') => {
        setShowConfirmation(true);
        setConfirmAction(true);
        setAction('delete');
        if (albumId) {
            const selectedAlbum = albumList.find(album => album.id == albumId);
            setModalBody(`Are you sure you want to delete the ${selectedAlbum.album_name} album?`);
        } else {
            setModalBody(`Are you sure you want to delete the album?`);
        }
    };

    const handleOpenAlbum = (album) => {
        dispatch(setActiveAlbum(album));
        dispatch(setAlbumAction('view_album'));
    };

    const onChangeRenameAlbum = (e) => {
        setRenameAlbum(e.target.value);
    };

    const updateAlbumName = () => {
        const formData = new FormData();
        formData.append('album_id', confirmAlbumID);
        formData.append('album_name', renameAlbum);
        axios({
            method: 'post',
            url: '/api/albums/update',
            data: formData,
        })
            .then((response) => {
                setAction('rename');
                dispatch(getAlbums());
                setConfirmAlbumID('');
                setShowAlert(true);
                setConfirmAction(true);
                setModalBody('The album name is updated');
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const deleteAlbum = () => {
        const formData = new FormData();
        formData.append('album_id', confirmAlbumID);
        axios({
            method: 'post',
            url: '/api/albums/delete/' + confirmAlbumID,
            data: formData,
        })
            .then((response) => {
                dispatch(getAlbums());
                setShowAlert(true);
                setConfirmAction(true);
                const deletedAlbum = albumList.find(album => confirmAlbumID == album.id);
                setModalBody(`Album ${deletedAlbum.album_name || ''} has been deleted`);
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const closeAlert = () => {
        setShowAlert(false);
        setConfirmAction(false);
        setAction('');
    };

    useDidMountEffect(() => {
        if (albumList && albumList.length > 0 && activeAlbum) {
            const data = albumList.find((album) => album.id === activeAlbum.id);
            if (data) {
                dispatch(setActiveAlbum(data));
            }
        }
    }, [albumList]);

    const listInnerRef = useRef();

    const handleOnScroll = () => {
        const { scrollTop } = listInnerRef.current;

        if (listInnerRef.current && !loadingStash) {
            dispatch(setStashAlbumListScrollPosition(scrollTop));
        }
    }

    useEffect(() => {

        const albumContainer = document.querySelector(".album_container");
        const { scrollTop } = listInnerRef.current;

        if (scrollTop === 0 && albumListScrollTopPosition > 0 && albumContainer !== null) {
            albumContainer.scrollTo(0, albumListScrollTopPosition);
        }

    }, [albumListScrollTopPosition]);

    return <>
        <div className="stash-albums album_container"
             onScroll={handleOnScroll}
             ref={listInnerRef}
        >
            {
                loadingStash && <div className="preloading-container">
                    <Spinner size="lg" animation="border" variant="primary" />
                </div>
            }
            {
                !loadingStash && <table className="table" id="albums_table">
                    <tbody>
                        {
                            albumList && albumList.map((album) => (
                                <tr key={album.id}>
                                    <td className="three_dots_cont">
                                        <Dropdown drop="down">
                                            <Dropdown.Toggle variant="success" className="album-threedots">
                                                <FontAwesomeIcon className="album_three_dot" icon={['fas', 'ellipsis-v']} />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => {
                                                    setConfirmAlbumID(album.id);
                                                    setRenameAlbum(album.album_name);
                                                    handleShowRenameFolder();
                                                }}>Rename Album</Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    setConfirmAlbumID(album.id);
                                                    setRenameAlbum('');
                                                    deleteAlbumConfirm(album.id);
                                                }}>Delete Album</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                    <td className="open_album"
                                        onClick={() => {
                                            handleOpenAlbum(album);
                                        }}
                                    >
                                        <b>{album.album_name}</b><br />
                                        <span className="album_stats">
                                            <FontAwesomeIcon icon={['fas', 'image']} /> {album.medias_img_count} &nbsp;
                                            <FontAwesomeIcon className="album_three_dot"
                                                icon={['fas', 'video']} /> {album.medias_video_count}
                                        </span>
                                    </td>
                                    <td className="album-thumb-col open_album">
                                        <div className="thumb-col-img">
                                            {
                                                album.medias.length
                                                    ? <img src={`${s3Link}/${album.medias[album.medias.length - 1]['thumb_path']}`} alt="" />
                                                    : ''
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }
                        {
                            !loadingStash && albumList.length <= 0 && <tr><td align='center'>No album found</td></tr>
                        }
                    </tbody>
                </table>
            }
        </div>
        {
            showRenameFolder && <ModalBootstrap show={showRenameFolder} onHide={handleShowRenameFolder} className="renamefolder-modal" centered size="sm">
                <ModalBootstrap.Header style={{ borderBottom: 'unset', paddingBottom: '0px' }}>
                    <ModalBootstrap.Title>Rename Album</ModalBootstrap.Title>
                </ModalBootstrap.Header>
                <ModalBootstrap.Body>
                    <div className="rename_album_cont">
                        <span>Album Name<br />
                            <input type="text" className='rounded' defaultValue={renameAlbum} onChange={onChangeRenameAlbum} />
                        </span>
                    </div>
                    <div className="new-album-buttons" style={{ fontWeight: '650' }}>
                        <span href="#" className="close-fancy" onClick={handleShowRenameFolder}>CANCEL</span>
                        <span href="#" className="save-rename-album" onClick={() => { updateAlbumName(); handleShowRenameFolder(); }}>UPDATE</span>
                    </div>
                </ModalBootstrap.Body>
            </ModalBootstrap>
        }
        {showAlert && <AlertConfirmModal show={showAlert} modalBody={modalBody} setShow={setShowAlert} />}
        {showConfirmation && <AlertConfirmModal show={showConfirmation} modalBody={modalBody} setShow={setShowConfirmation} isConfirm={confirmAction} setConfirm={setConfirmAction} useFunction={handleAlertFunction} />}
    </>;
};

const mapStateToProps = state => {
    return {
        activeAlbum: state.stash.activeAlbum,
        albumList: state.stash.albums,
        loadingStash: state.stash.busy,
        albumListScrollTopPosition: state.stash.albumListScrollTopPosition
    };
};

export default connect(mapStateToProps)(AlbumList);


